import axios from "axios";
import AuthConfig from "../Auth/AuthConfig";
import AuthFlowType from "../Auth/Enums/AuthFlowType";

import LocalStorageHelper from "../Helpers/LocalStorageHelper";

const apiRoot = __API_CONFIG.root;
const apiVersion = __API_CONFIG.version;
const apiFlowType = AuthConfig.authFlowType;

function _getCorrectBearerToken() {
	const auth = JSON.parse(LocalStorageHelper.get("auth", "{}"));
	if (apiFlowType === AuthFlowType.OAUTH) {
		return "Bearer " + auth.token.access_token;
	}
	else if (apiFlowType === AuthFlowType.USER_PASSWORD_AUTH) {
		return "Bearer " + auth.token.id_token;
	}
	return "";
}

const API = {};

API.request = (endpoint, type = "get", data = null) => {
	return new Promise((resolve, reject) => {
		const url = apiRoot + "/" + apiVersion + "/" + endpoint;

		// Note: API Gateway times out automatically after 29 seconds. Not much we can do about this!
		axios.defaults.timeout = 180 * 1000; // Three minutes?
		axios({
			url: url,
			method: type,
			data: data,
			headers: {
				Authorization: _getCorrectBearerToken()
			},
			validateStatus: false
		})
			.then((response) => {
				if (response.status !== 200) {
					response.success = false;
					reject(response, response.data);
					return;
				}
				response.success = true;
				resolve(response.data);
			})
			.catch((error) => {
				reject(error, {});
			});
	});
};
API.get = (endpoint, data) => {
	return API.request(endpoint, "get", data);
};
API.getDataset = (datasetKey) => {
	const completeResponse = "";
	const completeLength = 0;
	return new Promise((resolve, reject) => {
		API._getDatasetNextPage(datasetKey, 1, completeResponse, completeLength)
			.then((response) => {
				delete response.dataset.pagination;
				resolve(response);
			});
	});
};
API.getDatasetParsedJSON = (datasetKey) => {
	return new Promise((resolve, reject) => {
		API.getDataset(datasetKey)
			.then((response) => {
				resolve(JSON.parse(response.dataset.content));
			})
			.catch((err) => {
				reject(err);
			});
	});
};
API._getDatasetNextPage = async (datasetKey, page = 1, content = "", contentLength = 0) => {
	const response = await API.get("datasets/" + datasetKey + "?page=" + page);

	content += response.dataset.content;
	contentLength += response.dataset.content.length;

	if (response.dataset.pagination.page < response.dataset.pagination.total) {
		const r = await API._getDatasetNextPage(datasetKey, page + 1, content, contentLength);
		return r;
	}
	else {
		response.dataset.content = content;
		response.dataset.length = contentLength;
		return response;
	}
};
API.post = (endpoint, data) => {
	return API.request(endpoint, "post", data);
};
API.put = (endpoint, data) => {
	return API.request(endpoint, "put", data);
};
API.delete = (endpoint, data) => {
	return API.request(endpoint, "delete", data);
};

API.currentUser = () => {
	return API.get("users/current");
};
API.alerts = (alertTypes = [], companyId = null) => {
	let typesStr = "";
	if (alertTypes.length > 0) {
		if (Array.isArray(alertTypes)) {
			typesStr = "?type=" + alertTypes.join(",");
		}
		else {
			typesStr = "?type=" + alertTypes;
		}
	}
	if (companyId != null) {
		typesStr += (typesStr.length === 0) ? "?" : "&";
		typesStr += "company_id=" + companyId;
	}
	return API.request("alerts" + typesStr);
};
export default API;
